export default __webpack_public_path__ + "static/media/2829 cutlery top.5c6d6b90.png";